import { NumberModule } from './pipes/number.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from './shared/shared.module';

import { ROUTES } from './app.routes';

import { EquipamentoService, UsuarioService, DadosService, ProdutoService, MensagemService } from './services/service';


import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';

import { AuthGuard } from './guards/auth.guard';
import { DadosComponent } from './dados/dados.component';
import { ProdutoPesquisaComponent } from './produto_pesquisa/produto_pesquisa.component';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DadosComponent,
    ProdutoPesquisaComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(ROUTES),
    SharedModule.forRoot(),
    CommonModule, 
    ReactiveFormsModule,
    NumberModule.forRoot()
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    EquipamentoService,
    MensagemService,
    UsuarioService,
    AuthGuard,
    DadosService,
    ProdutoService
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { 
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts